import { Injectable } from '@angular/core';
import { Ref, Globals } from '../globals';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs';

export interface ExpenseConcept{
  id?: string;
  expenseCategoryRef: Ref;
  name: string;
}

@Injectable()
export class ExpenseConceptService {

  collection: string;

  constructor(
    private afh: FirestoreService,
  ) {
    this.collection = Globals.EXPENSE_CONCEPT_COLLECTION;
  }

  /**
   * Get all expenseConcepts with references
   * @return {Observable} Arrays of expenseConcepts
   */
  getExpenseConcepts(): Observable<ExpenseConcept[]> {
    return this.afh.colWithIds$(this.collection, ref => ref.orderBy('name', 'asc')/* .where('active', '==', true) */ );
  }

  /**
  * Get expenseConcept data
  * @param {string} sid - The id of the expenseConcept
  * @return {Observable} The ExpenseConcept Object
  */
  getExpenseConcept(sid: string): Observable<ExpenseConcept> {
    return this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Create new expenseConcept
  * @param {ExpenseConcept} expenseConcept - The data of the expenseConcept
  */
  addExpenseConcept(expenseConcept: ExpenseConcept) {
    this.afh.add(`${this.collection}`, expenseConcept);
  }

  /**
   * Update current expenseConcept
   * @param {string} sid  - The id of the expenseConcept
   * @param {ExpenseConcept} expenseConcept - The data of the expenseConcept
   */
  updateExpenseConcept(sid: string, expenseConcept: Partial<ExpenseConcept>) {
    this.afh.update(`${this.collection}/${sid}`, expenseConcept);
  }

  /**
   * Delete current expenseConcept
   * @param {string} sid - The id of the expenseConcept
   */
  deleteExpenseConcept(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  getDocRef(docId: string){
    return this.afh.doc(`${this.collection}/${docId}`).ref;
  }
}